// @ts-nocheck
// Fiore pixel-art come singolo div con sprite SVG in background.
// La versione precedente creava 8 nodi DOM per fiore (stelo, 4 petali con
// box-shadow, centro, foglia): con 10-18 fiori per chunk diventavano migliaia
// di nodi nel layer #world e un costo di raster visibile durante il pan.
// Lo sprite replica lo stesso layout in viewBox 10×16 (proporzione 1:1.6).

const COLORS = [
  { petal: "#ff6b9d", center: "#ffd93d" }, // Rosa-giallo brillante
  { petal: "#a29bfe", center: "#ffeaa7" }, // Lavanda-giallo
  { petal: "#fd79a8", center: "#ffffff" }, // Rosa chiaro-bianco
  { petal: "#ff7675", center: "#fdcb6e" }, // Rosso corallo-arancione
  { petal: "#74b9ff", center: "#ffeaa7" }, // Azzurro-giallo
  { petal: "#a29bfe", center: "#ffffff" }, // Viola-bianco
  { petal: "#fd79a8", center: "#ffeaa7" }, // Rosa-giallo
  { petal: "#00cec9", center: "#fdcb6e" }, // Turchese-arancione
  { petal: "#ffa502", center: "#ffffff" }, // Arancione-bianco
  { petal: "#ff6348", center: "#ffd93d" }, // Rosso-giallo
  { petal: "#e056fd", center: "#ffeaa7" }, // Magenta-giallo
  { petal: "#55efc4", center: "#ffffff" }, // Verde menta-bianco
];

const spriteCache: string[] = [];

function flowerSprite(colorIdx) {
  const i = colorIdx % COLORS.length;
  if (spriteCache[i]) return spriteCache[i];

  const c = COLORS[i];
  // Foglia a sinistra per varianti pari, a destra per le dispari (come prima).
  const leafX = i % 2 === 0 ? -0.2 : 6.7;

  const svg =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 16">' +
    '<filter id="s" x="-50%" y="-50%" width="200%" height="200%">' +
    '<feDropShadow dx="0" dy="0.4" stdDeviation="0.35" flood-color="#000" flood-opacity="0.15"/>' +
    "</filter>" +
    // Stelo: 0.18×size, alto 0.75×size, centrato sul fondo
    '<rect x="4.1" y="8.5" width="1.8" height="7.5" fill="#4a8c2a"/>' +
    // 4 petali (diametro 0.4×size) nelle stesse posizioni della versione DOM
    '<g filter="url(#s)" fill="' + c.petal + '">' +
    '<circle cx="5" cy="2" r="2"/>' +
    '<circle cx="2" cy="6" r="2"/>' +
    '<circle cx="8" cy="6" r="2"/>' +
    '<circle cx="5" cy="10" r="2"/>' +
    "</g>" +
    // Centro (0.3×size) con anello scuro al posto dell'inset shadow
    '<circle cx="5" cy="5.5" r="1.5" fill="' + c.center + '"/>' +
    '<circle cx="5" cy="5.5" r="1.35" fill="none" stroke="rgba(0,0,0,0.14)" stroke-width="0.3"/>' +
    // Foglia 0.35×size × 0.21×size, a 0.3×size dal fondo
    '<rect x="' + leafX + '" y="10.9" width="3.5" height="2.1" rx="0.7" fill="#5a9e35"/>' +
    "</svg>";

  spriteCache[i] = 'url("data:image/svg+xml,' + encodeURIComponent(svg) + '")';
  return spriteCache[i];
}

export function createPixelFlower(size, colorIdx) {
  const el = document.createElement("div");
  el.className = "pixel-flower";
  el.style.width = size + "px";
  el.style.height = size * 1.6 + "px";
  el.style.backgroundImage = flowerSprite(colorIdx);
  return el;
}
